<template>
  <b-container class="px-0" >
    <b-row v-if="!correctToken">
      <b-col class="mt-4 text-center" cols="12">
        <h3>{{$tr('resetPassword.token-unverified','Token is unverified. Try again change your password.')}}</h3>
      </b-col>
      <b-col class="text-center pt-3" cols="12">
        <b-link to="/">{{$tr('resetPassword.back-home','Back to home page.')}}</b-link>
      </b-col>
    </b-row>
    <b-row v-else no-gutters>
      <b-col class="pt-5">
        <b-card header-tag="header" >
          <template v-slot:header>
            <h6 class="mb-0">{{$tr('resetPassword.change-password','Change password')}}</h6>
          </template>
          <template>
            <h4 v-if="user" class="text-center mb-4">{{$tr('resetPassword.info-change-password','Hello #{1} ! You can now change your password.', user.login)}}</h4>
          </template>
          <b-card-text>

            <b-form v-on:keydown.enter="enterTriggerChangePassword">

              <reach-input
                  data-test-path="add-new-password"
                  :label="$tr('enterNewPassword','Enter a new password')"
                  :help-title="$tr('password','Password')"
                  :help-message="passwordHelp"
                  :formField="form.password"
                  :hint="$tr('resetPassword.characters','Min 6 characters; mix at least two of: capital/small/number/special character')"
                  type="password"
                  autocomplete="new-password"
              >
              </reach-input>

              <reach-input
                  data-test-path="add-new-password2"
                  :label="$tr('resetPassword.repeat-new-password','Repeat a new password')"
                  :help-title="$tr('repeatPassword','Repeat password')"
                  :help-message="$tr('resetPassword.both','Both passwords need to match')"
                  :formField="form.password2"
                  :hint="$tr('resetPassword.both','Both passwords need to match')"
                  type="password"
                  autocomplete="new-password"
              >
              </reach-input>

            </b-form>
          </b-card-text>

          <b-button
              data-test-path="btn-reset-password"
              :disabled="this.form.password.value === '' || this.form.password2.value === '' || !this.form.password.isValid || !this.form.password2.isValid"
              variant="plm-primary"
              @click="resetPassword()">Reset my password
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ReachInput from "@/components/inputs/ReachInput";
import ApplicationUser from "@/server/com/silkplm/model/users/ApplicationUser";
import ChangePasswordForm from "@/components/users/ChangePasswordForm";


export default {
  name: "ResetPassword",
  components: {ReachInput},

  async mounted(){
    this.user = await Rpc.Users.verifyToken(this.token);
    if(this.user){
      this.correctToken = true;
    }
  },

  methods: {

    enterTriggerChangePassword(event){
      if (event.key === 'Enter') {
        this.resetPassword();
      }
    },

    async resetPassword(){
     let result =  await Rpc.Users.changePasswordWithToken(this.form.password.value, this.token);
     if(result){
       window.location.href="/dashboard";
     }
     else{
       await DialogManager.info($tr('resetPassword.info-reset-failed','Password reset failed'),
           $tr('resetPassword.info-try-again','Please try again'));
     }
    }

  },

  props: {
    token:              {type: String,  default:null },

  },

  data: () => ({
    correctToken: true,
    user: new ApplicationUser(),
    form: new ChangePasswordForm(),
    passwordHelp:
        `<div> Min 6 characters; <br> Mix at least two of: <br>
                <ul style="display: inline-block">
                    <li>capital</li>
                    <li>small</li>
                    <li>number</li>
                    <li>special char</li>
                </ul>
           </div>`
  })
}

</script>
